import type { PriceBookSheetRowView } from '@/document-render/domain/priceBook/buildPriceBookBySheetView';
import { HIDDEN_OPACITY, rateBodyCellStyle } from './priceBookSheetStyles';

/** A read-only rate row (preview before customising, and the customer audience). */
export function PriceBookRateRow({ row }: { row: PriceBookSheetRowView }) {
  return (
    <tr data-price-book-row-id={row.id} style={{ opacity: row.dimmed ? HIDDEN_OPACITY : undefined }}>
      {row.cells.map((cell) => (
        <td key={cell.key} style={rateBodyCellStyle(cell.align, cell.emphasis)}>
          {cell.text}
        </td>
      ))}
    </tr>
  );
}
